// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: knowledge_base.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "knowledge_base";

export interface ExampleQueries {
  queries: string[];
}

export interface TopicReferences {
  sms: { [key: string]: boolean };
  handoff: { [key: string]: boolean };
  attributes: { [key: string]: boolean };
  globalFunctions: { [key: string]: boolean };
  variables: { [key: string]: boolean };
  translations: { [key: string]: boolean };
}

export interface TopicReferences_SmsEntry {
  key: string;
  value: boolean;
}

export interface TopicReferences_HandoffEntry {
  key: string;
  value: boolean;
}

export interface TopicReferences_AttributesEntry {
  key: string;
  value: boolean;
}

export interface TopicReferences_GlobalFunctionsEntry {
  key: string;
  value: boolean;
}

export interface TopicReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface TopicReferences_TranslationsEntry {
  key: string;
  value: boolean;
}

/** persisted messages */
export interface KnowledgeBase {
  topics: KnowledgeBaseTopic[];
  embeddingModel: string;
}

export interface KnowledgeBaseTopic {
  id: string;
  name: string;
  content: string;
  actions: string;
  exampleQueries: ExampleQueries | undefined;
  references: TopicReferences | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  /** Using optional to distinguish "not set" (old topics) from "explicitly false" */
  isActive?: boolean | undefined;
}

/** commands to operate on knowledge base */
export interface KnowledgeBaseCreateTopic {
  id: string;
  name: string;
  content: string;
  actions: string;
  exampleQueries: ExampleQueries | undefined;
  references: TopicReferences | undefined;
  isActive?: boolean | undefined;
}

/** use optionals to allow only updating some fields */
export interface KnowledgeBaseUpdateTopic {
  id: string;
  name?: string | undefined;
  content?: string | undefined;
  actions?: string | undefined;
  exampleQueries?: ExampleQueries | undefined;
  references?: TopicReferences | undefined;
  isActive?: boolean | undefined;
}

export interface KnowledgeBaseDeleteTopic {
  id: string;
}

export interface KnowledgeBaseToggleTopicStatus {
  id: string;
  isActive: boolean;
}

export interface KnowledgeBaseImportTopics {
  created: KnowledgeBaseCreateTopic[];
  updated: KnowledgeBaseUpdateTopic[];
  deleted: string[];
  source?: string | undefined;
  metadata?: ImportMetadata | undefined;
}

export interface ImportMetadata {
  totalTopics: number;
  importTimestamp: string;
  fileName?: string | undefined;
}

function createBaseExampleQueries(): ExampleQueries {
  return { queries: [] };
}

export const ExampleQueries: MessageFns<ExampleQueries> = {
  encode(message: ExampleQueries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.queries) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExampleQueries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExampleQueries();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.queries.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExampleQueries {
    return {
      queries: globalThis.Array.isArray(object?.queries) ? object.queries.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ExampleQueries): unknown {
    const obj: any = {};
    if (message.queries?.length) {
      obj.queries = message.queries;
    }
    return obj;
  },

  create(base?: DeepPartial<ExampleQueries>): ExampleQueries {
    return ExampleQueries.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExampleQueries>): ExampleQueries {
    const message = createBaseExampleQueries();
    message.queries = object.queries?.map((e) => e) || [];
    return message;
  },
};

function createBaseTopicReferences(): TopicReferences {
  return { sms: {}, handoff: {}, attributes: {}, globalFunctions: {}, variables: {}, translations: {} };
}

export const TopicReferences: MessageFns<TopicReferences> = {
  encode(message: TopicReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.sms).forEach(([key, value]: [string, boolean]) => {
      TopicReferences_SmsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.handoff).forEach(([key, value]: [string, boolean]) => {
      TopicReferences_HandoffEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.attributes).forEach(([key, value]: [string, boolean]) => {
      TopicReferences_AttributesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.globalFunctions).forEach(([key, value]: [string, boolean]) => {
      TopicReferences_GlobalFunctionsEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      TopicReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    globalThis.Object.entries(message.translations).forEach(([key, value]: [string, boolean]) => {
      TopicReferences_TranslationsEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = TopicReferences_SmsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.sms[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = TopicReferences_HandoffEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.handoff[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = TopicReferences_AttributesEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.attributes[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = TopicReferences_GlobalFunctionsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.globalFunctions[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = TopicReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.variables[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = TopicReferences_TranslationsEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.translations[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicReferences {
    return {
      sms: isObject(object.sms)
        ? (globalThis.Object.entries(object.sms) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      handoff: isObject(object.handoff)
        ? (globalThis.Object.entries(object.handoff) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      attributes: isObject(object.attributes)
        ? (globalThis.Object.entries(object.attributes) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      globalFunctions: isObject(object.globalFunctions)
        ? (globalThis.Object.entries(object.globalFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.global_functions)
        ? (globalThis.Object.entries(object.global_functions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      translations: isObject(object.translations)
        ? (globalThis.Object.entries(object.translations) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: TopicReferences): unknown {
    const obj: any = {};
    if (message.sms) {
      const entries = globalThis.Object.entries(message.sms) as [string, boolean][];
      if (entries.length > 0) {
        obj.sms = {};
        entries.forEach(([k, v]) => {
          obj.sms[k] = v;
        });
      }
    }
    if (message.handoff) {
      const entries = globalThis.Object.entries(message.handoff) as [string, boolean][];
      if (entries.length > 0) {
        obj.handoff = {};
        entries.forEach(([k, v]) => {
          obj.handoff[k] = v;
        });
      }
    }
    if (message.attributes) {
      const entries = globalThis.Object.entries(message.attributes) as [string, boolean][];
      if (entries.length > 0) {
        obj.attributes = {};
        entries.forEach(([k, v]) => {
          obj.attributes[k] = v;
        });
      }
    }
    if (message.globalFunctions) {
      const entries = globalThis.Object.entries(message.globalFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.globalFunctions = {};
        entries.forEach(([k, v]) => {
          obj.globalFunctions[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    if (message.translations) {
      const entries = globalThis.Object.entries(message.translations) as [string, boolean][];
      if (entries.length > 0) {
        obj.translations = {};
        entries.forEach(([k, v]) => {
          obj.translations[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<TopicReferences>): TopicReferences {
    return TopicReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TopicReferences>): TopicReferences {
    const message = createBaseTopicReferences();
    message.sms = (globalThis.Object.entries(object.sms ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.handoff = (globalThis.Object.entries(object.handoff ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.attributes = (globalThis.Object.entries(object.attributes ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.globalFunctions = (globalThis.Object.entries(object.globalFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.translations = (globalThis.Object.entries(object.translations ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseTopicReferences_SmsEntry(): TopicReferences_SmsEntry {
  return { key: "", value: false };
}

export const TopicReferences_SmsEntry: MessageFns<TopicReferences_SmsEntry> = {
  encode(message: TopicReferences_SmsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicReferences_SmsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicReferences_SmsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicReferences_SmsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TopicReferences_SmsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TopicReferences_SmsEntry>): TopicReferences_SmsEntry {
    return TopicReferences_SmsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TopicReferences_SmsEntry>): TopicReferences_SmsEntry {
    const message = createBaseTopicReferences_SmsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTopicReferences_HandoffEntry(): TopicReferences_HandoffEntry {
  return { key: "", value: false };
}

export const TopicReferences_HandoffEntry: MessageFns<TopicReferences_HandoffEntry> = {
  encode(message: TopicReferences_HandoffEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicReferences_HandoffEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicReferences_HandoffEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicReferences_HandoffEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TopicReferences_HandoffEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TopicReferences_HandoffEntry>): TopicReferences_HandoffEntry {
    return TopicReferences_HandoffEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TopicReferences_HandoffEntry>): TopicReferences_HandoffEntry {
    const message = createBaseTopicReferences_HandoffEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTopicReferences_AttributesEntry(): TopicReferences_AttributesEntry {
  return { key: "", value: false };
}

export const TopicReferences_AttributesEntry: MessageFns<TopicReferences_AttributesEntry> = {
  encode(message: TopicReferences_AttributesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicReferences_AttributesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicReferences_AttributesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicReferences_AttributesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TopicReferences_AttributesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TopicReferences_AttributesEntry>): TopicReferences_AttributesEntry {
    return TopicReferences_AttributesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TopicReferences_AttributesEntry>): TopicReferences_AttributesEntry {
    const message = createBaseTopicReferences_AttributesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTopicReferences_GlobalFunctionsEntry(): TopicReferences_GlobalFunctionsEntry {
  return { key: "", value: false };
}

export const TopicReferences_GlobalFunctionsEntry: MessageFns<TopicReferences_GlobalFunctionsEntry> = {
  encode(message: TopicReferences_GlobalFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicReferences_GlobalFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicReferences_GlobalFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicReferences_GlobalFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TopicReferences_GlobalFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TopicReferences_GlobalFunctionsEntry>): TopicReferences_GlobalFunctionsEntry {
    return TopicReferences_GlobalFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TopicReferences_GlobalFunctionsEntry>): TopicReferences_GlobalFunctionsEntry {
    const message = createBaseTopicReferences_GlobalFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTopicReferences_VariablesEntry(): TopicReferences_VariablesEntry {
  return { key: "", value: false };
}

export const TopicReferences_VariablesEntry: MessageFns<TopicReferences_VariablesEntry> = {
  encode(message: TopicReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TopicReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TopicReferences_VariablesEntry>): TopicReferences_VariablesEntry {
    return TopicReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TopicReferences_VariablesEntry>): TopicReferences_VariablesEntry {
    const message = createBaseTopicReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTopicReferences_TranslationsEntry(): TopicReferences_TranslationsEntry {
  return { key: "", value: false };
}

export const TopicReferences_TranslationsEntry: MessageFns<TopicReferences_TranslationsEntry> = {
  encode(message: TopicReferences_TranslationsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicReferences_TranslationsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicReferences_TranslationsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicReferences_TranslationsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TopicReferences_TranslationsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TopicReferences_TranslationsEntry>): TopicReferences_TranslationsEntry {
    return TopicReferences_TranslationsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TopicReferences_TranslationsEntry>): TopicReferences_TranslationsEntry {
    const message = createBaseTopicReferences_TranslationsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseKnowledgeBase(): KnowledgeBase {
  return { topics: [], embeddingModel: "" };
}

export const KnowledgeBase: MessageFns<KnowledgeBase> = {
  encode(message: KnowledgeBase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.topics) {
      KnowledgeBaseTopic.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.embeddingModel !== "") {
      writer.uint32(18).string(message.embeddingModel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KnowledgeBase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKnowledgeBase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topics.push(KnowledgeBaseTopic.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.embeddingModel = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KnowledgeBase {
    return {
      topics: globalThis.Array.isArray(object?.topics)
        ? object.topics.map((e: any) => KnowledgeBaseTopic.fromJSON(e))
        : [],
      embeddingModel: isSet(object.embeddingModel)
        ? globalThis.String(object.embeddingModel)
        : isSet(object.embedding_model)
        ? globalThis.String(object.embedding_model)
        : "",
    };
  },

  toJSON(message: KnowledgeBase): unknown {
    const obj: any = {};
    if (message.topics?.length) {
      obj.topics = message.topics.map((e) => KnowledgeBaseTopic.toJSON(e));
    }
    if (message.embeddingModel !== "") {
      obj.embeddingModel = message.embeddingModel;
    }
    return obj;
  },

  create(base?: DeepPartial<KnowledgeBase>): KnowledgeBase {
    return KnowledgeBase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KnowledgeBase>): KnowledgeBase {
    const message = createBaseKnowledgeBase();
    message.topics = object.topics?.map((e) => KnowledgeBaseTopic.fromPartial(e)) || [];
    message.embeddingModel = object.embeddingModel ?? "";
    return message;
  },
};

function createBaseKnowledgeBaseTopic(): KnowledgeBaseTopic {
  return {
    id: "",
    name: "",
    content: "",
    actions: "",
    exampleQueries: undefined,
    references: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    isActive: undefined,
  };
}

export const KnowledgeBaseTopic: MessageFns<KnowledgeBaseTopic> = {
  encode(message: KnowledgeBaseTopic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.content !== "") {
      writer.uint32(26).string(message.content);
    }
    if (message.actions !== "") {
      writer.uint32(34).string(message.actions);
    }
    if (message.exampleQueries !== undefined) {
      ExampleQueries.encode(message.exampleQueries, writer.uint32(42).fork()).join();
    }
    if (message.references !== undefined) {
      TopicReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(66).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(74).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(82).string(message.updatedBy);
    }
    if (message.isActive !== undefined) {
      writer.uint32(88).bool(message.isActive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KnowledgeBaseTopic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKnowledgeBaseTopic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actions = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.exampleQueries = ExampleQueries.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = TopicReferences.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KnowledgeBaseTopic {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      actions: isSet(object.actions) ? globalThis.String(object.actions) : "",
      exampleQueries: isSet(object.exampleQueries)
        ? ExampleQueries.fromJSON(object.exampleQueries)
        : isSet(object.example_queries)
        ? ExampleQueries.fromJSON(object.example_queries)
        : undefined,
      references: isSet(object.references) ? TopicReferences.fromJSON(object.references) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : undefined,
    };
  },

  toJSON(message: KnowledgeBaseTopic): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.actions !== "") {
      obj.actions = message.actions;
    }
    if (message.exampleQueries !== undefined) {
      obj.exampleQueries = ExampleQueries.toJSON(message.exampleQueries);
    }
    if (message.references !== undefined) {
      obj.references = TopicReferences.toJSON(message.references);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.isActive !== undefined) {
      obj.isActive = message.isActive;
    }
    return obj;
  },

  create(base?: DeepPartial<KnowledgeBaseTopic>): KnowledgeBaseTopic {
    return KnowledgeBaseTopic.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KnowledgeBaseTopic>): KnowledgeBaseTopic {
    const message = createBaseKnowledgeBaseTopic();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.content = object.content ?? "";
    message.actions = object.actions ?? "";
    message.exampleQueries = (object.exampleQueries !== undefined && object.exampleQueries !== null)
      ? ExampleQueries.fromPartial(object.exampleQueries)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? TopicReferences.fromPartial(object.references)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.isActive = object.isActive ?? undefined;
    return message;
  },
};

function createBaseKnowledgeBaseCreateTopic(): KnowledgeBaseCreateTopic {
  return {
    id: "",
    name: "",
    content: "",
    actions: "",
    exampleQueries: undefined,
    references: undefined,
    isActive: undefined,
  };
}

export const KnowledgeBaseCreateTopic: MessageFns<KnowledgeBaseCreateTopic> = {
  encode(message: KnowledgeBaseCreateTopic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.content !== "") {
      writer.uint32(26).string(message.content);
    }
    if (message.actions !== "") {
      writer.uint32(34).string(message.actions);
    }
    if (message.exampleQueries !== undefined) {
      ExampleQueries.encode(message.exampleQueries, writer.uint32(50).fork()).join();
    }
    if (message.references !== undefined) {
      TopicReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    if (message.isActive !== undefined) {
      writer.uint32(64).bool(message.isActive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KnowledgeBaseCreateTopic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKnowledgeBaseCreateTopic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actions = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.exampleQueries = ExampleQueries.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = TopicReferences.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KnowledgeBaseCreateTopic {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      actions: isSet(object.actions) ? globalThis.String(object.actions) : "",
      exampleQueries: isSet(object.exampleQueries)
        ? ExampleQueries.fromJSON(object.exampleQueries)
        : isSet(object.example_queries)
        ? ExampleQueries.fromJSON(object.example_queries)
        : undefined,
      references: isSet(object.references) ? TopicReferences.fromJSON(object.references) : undefined,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : undefined,
    };
  },

  toJSON(message: KnowledgeBaseCreateTopic): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.actions !== "") {
      obj.actions = message.actions;
    }
    if (message.exampleQueries !== undefined) {
      obj.exampleQueries = ExampleQueries.toJSON(message.exampleQueries);
    }
    if (message.references !== undefined) {
      obj.references = TopicReferences.toJSON(message.references);
    }
    if (message.isActive !== undefined) {
      obj.isActive = message.isActive;
    }
    return obj;
  },

  create(base?: DeepPartial<KnowledgeBaseCreateTopic>): KnowledgeBaseCreateTopic {
    return KnowledgeBaseCreateTopic.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KnowledgeBaseCreateTopic>): KnowledgeBaseCreateTopic {
    const message = createBaseKnowledgeBaseCreateTopic();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.content = object.content ?? "";
    message.actions = object.actions ?? "";
    message.exampleQueries = (object.exampleQueries !== undefined && object.exampleQueries !== null)
      ? ExampleQueries.fromPartial(object.exampleQueries)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? TopicReferences.fromPartial(object.references)
      : undefined;
    message.isActive = object.isActive ?? undefined;
    return message;
  },
};

function createBaseKnowledgeBaseUpdateTopic(): KnowledgeBaseUpdateTopic {
  return {
    id: "",
    name: undefined,
    content: undefined,
    actions: undefined,
    exampleQueries: undefined,
    references: undefined,
    isActive: undefined,
  };
}

export const KnowledgeBaseUpdateTopic: MessageFns<KnowledgeBaseUpdateTopic> = {
  encode(message: KnowledgeBaseUpdateTopic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.content !== undefined) {
      writer.uint32(26).string(message.content);
    }
    if (message.actions !== undefined) {
      writer.uint32(34).string(message.actions);
    }
    if (message.exampleQueries !== undefined) {
      ExampleQueries.encode(message.exampleQueries, writer.uint32(42).fork()).join();
    }
    if (message.references !== undefined) {
      TopicReferences.encode(message.references, writer.uint32(50).fork()).join();
    }
    if (message.isActive !== undefined) {
      writer.uint32(56).bool(message.isActive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KnowledgeBaseUpdateTopic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKnowledgeBaseUpdateTopic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actions = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.exampleQueries = ExampleQueries.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.references = TopicReferences.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KnowledgeBaseUpdateTopic {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      actions: isSet(object.actions) ? globalThis.String(object.actions) : undefined,
      exampleQueries: isSet(object.exampleQueries)
        ? ExampleQueries.fromJSON(object.exampleQueries)
        : isSet(object.example_queries)
        ? ExampleQueries.fromJSON(object.example_queries)
        : undefined,
      references: isSet(object.references) ? TopicReferences.fromJSON(object.references) : undefined,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : undefined,
    };
  },

  toJSON(message: KnowledgeBaseUpdateTopic): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.actions !== undefined) {
      obj.actions = message.actions;
    }
    if (message.exampleQueries !== undefined) {
      obj.exampleQueries = ExampleQueries.toJSON(message.exampleQueries);
    }
    if (message.references !== undefined) {
      obj.references = TopicReferences.toJSON(message.references);
    }
    if (message.isActive !== undefined) {
      obj.isActive = message.isActive;
    }
    return obj;
  },

  create(base?: DeepPartial<KnowledgeBaseUpdateTopic>): KnowledgeBaseUpdateTopic {
    return KnowledgeBaseUpdateTopic.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KnowledgeBaseUpdateTopic>): KnowledgeBaseUpdateTopic {
    const message = createBaseKnowledgeBaseUpdateTopic();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.content = object.content ?? undefined;
    message.actions = object.actions ?? undefined;
    message.exampleQueries = (object.exampleQueries !== undefined && object.exampleQueries !== null)
      ? ExampleQueries.fromPartial(object.exampleQueries)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? TopicReferences.fromPartial(object.references)
      : undefined;
    message.isActive = object.isActive ?? undefined;
    return message;
  },
};

function createBaseKnowledgeBaseDeleteTopic(): KnowledgeBaseDeleteTopic {
  return { id: "" };
}

export const KnowledgeBaseDeleteTopic: MessageFns<KnowledgeBaseDeleteTopic> = {
  encode(message: KnowledgeBaseDeleteTopic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KnowledgeBaseDeleteTopic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKnowledgeBaseDeleteTopic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KnowledgeBaseDeleteTopic {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: KnowledgeBaseDeleteTopic): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<KnowledgeBaseDeleteTopic>): KnowledgeBaseDeleteTopic {
    return KnowledgeBaseDeleteTopic.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KnowledgeBaseDeleteTopic>): KnowledgeBaseDeleteTopic {
    const message = createBaseKnowledgeBaseDeleteTopic();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseKnowledgeBaseToggleTopicStatus(): KnowledgeBaseToggleTopicStatus {
  return { id: "", isActive: false };
}

export const KnowledgeBaseToggleTopicStatus: MessageFns<KnowledgeBaseToggleTopicStatus> = {
  encode(message: KnowledgeBaseToggleTopicStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.isActive !== false) {
      writer.uint32(16).bool(message.isActive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KnowledgeBaseToggleTopicStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKnowledgeBaseToggleTopicStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KnowledgeBaseToggleTopicStatus {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
    };
  },

  toJSON(message: KnowledgeBaseToggleTopicStatus): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    return obj;
  },

  create(base?: DeepPartial<KnowledgeBaseToggleTopicStatus>): KnowledgeBaseToggleTopicStatus {
    return KnowledgeBaseToggleTopicStatus.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KnowledgeBaseToggleTopicStatus>): KnowledgeBaseToggleTopicStatus {
    const message = createBaseKnowledgeBaseToggleTopicStatus();
    message.id = object.id ?? "";
    message.isActive = object.isActive ?? false;
    return message;
  },
};

function createBaseKnowledgeBaseImportTopics(): KnowledgeBaseImportTopics {
  return { created: [], updated: [], deleted: [], source: undefined, metadata: undefined };
}

export const KnowledgeBaseImportTopics: MessageFns<KnowledgeBaseImportTopics> = {
  encode(message: KnowledgeBaseImportTopics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.created) {
      KnowledgeBaseCreateTopic.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.updated) {
      KnowledgeBaseUpdateTopic.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.deleted) {
      writer.uint32(26).string(v!);
    }
    if (message.source !== undefined) {
      writer.uint32(34).string(message.source);
    }
    if (message.metadata !== undefined) {
      ImportMetadata.encode(message.metadata, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KnowledgeBaseImportTopics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKnowledgeBaseImportTopics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.created.push(KnowledgeBaseCreateTopic.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updated.push(KnowledgeBaseUpdateTopic.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deleted.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.source = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.metadata = ImportMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KnowledgeBaseImportTopics {
    return {
      created: globalThis.Array.isArray(object?.created)
        ? object.created.map((e: any) => KnowledgeBaseCreateTopic.fromJSON(e))
        : [],
      updated: globalThis.Array.isArray(object?.updated)
        ? object.updated.map((e: any) => KnowledgeBaseUpdateTopic.fromJSON(e))
        : [],
      deleted: globalThis.Array.isArray(object?.deleted) ? object.deleted.map((e: any) => globalThis.String(e)) : [],
      source: isSet(object.source) ? globalThis.String(object.source) : undefined,
      metadata: isSet(object.metadata) ? ImportMetadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: KnowledgeBaseImportTopics): unknown {
    const obj: any = {};
    if (message.created?.length) {
      obj.created = message.created.map((e) => KnowledgeBaseCreateTopic.toJSON(e));
    }
    if (message.updated?.length) {
      obj.updated = message.updated.map((e) => KnowledgeBaseUpdateTopic.toJSON(e));
    }
    if (message.deleted?.length) {
      obj.deleted = message.deleted;
    }
    if (message.source !== undefined) {
      obj.source = message.source;
    }
    if (message.metadata !== undefined) {
      obj.metadata = ImportMetadata.toJSON(message.metadata);
    }
    return obj;
  },

  create(base?: DeepPartial<KnowledgeBaseImportTopics>): KnowledgeBaseImportTopics {
    return KnowledgeBaseImportTopics.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KnowledgeBaseImportTopics>): KnowledgeBaseImportTopics {
    const message = createBaseKnowledgeBaseImportTopics();
    message.created = object.created?.map((e) => KnowledgeBaseCreateTopic.fromPartial(e)) || [];
    message.updated = object.updated?.map((e) => KnowledgeBaseUpdateTopic.fromPartial(e)) || [];
    message.deleted = object.deleted?.map((e) => e) || [];
    message.source = object.source ?? undefined;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? ImportMetadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseImportMetadata(): ImportMetadata {
  return { totalTopics: 0, importTimestamp: "", fileName: undefined };
}

export const ImportMetadata: MessageFns<ImportMetadata> = {
  encode(message: ImportMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalTopics !== 0) {
      writer.uint32(8).int32(message.totalTopics);
    }
    if (message.importTimestamp !== "") {
      writer.uint32(18).string(message.importTimestamp);
    }
    if (message.fileName !== undefined) {
      writer.uint32(26).string(message.fileName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.totalTopics = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.importTimestamp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImportMetadata {
    return {
      totalTopics: isSet(object.totalTopics)
        ? globalThis.Number(object.totalTopics)
        : isSet(object.total_topics)
        ? globalThis.Number(object.total_topics)
        : 0,
      importTimestamp: isSet(object.importTimestamp)
        ? globalThis.String(object.importTimestamp)
        : isSet(object.import_timestamp)
        ? globalThis.String(object.import_timestamp)
        : "",
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : undefined,
    };
  },

  toJSON(message: ImportMetadata): unknown {
    const obj: any = {};
    if (message.totalTopics !== 0) {
      obj.totalTopics = Math.round(message.totalTopics);
    }
    if (message.importTimestamp !== "") {
      obj.importTimestamp = message.importTimestamp;
    }
    if (message.fileName !== undefined) {
      obj.fileName = message.fileName;
    }
    return obj;
  },

  create(base?: DeepPartial<ImportMetadata>): ImportMetadata {
    return ImportMetadata.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ImportMetadata>): ImportMetadata {
    const message = createBaseImportMetadata();
    message.totalTopics = object.totalTopics ?? 0;
    message.importTimestamp = object.importTimestamp ?? "";
    message.fileName = object.fileName ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
